import { Typography } from '@saucelabs/ds-typography';
import React from 'react';
import classnames from 'classnames';

import { ImageType } from '../../global/constants';
import { useVisualSelector } from '../../reduxHooks';
import { selectors } from '../../ducks/diffUi';
import { DiffUiDisplayType } from '../../ducks/diffUi/constants';

type Props = React.PropsWithChildren<{
  side: ImageType;
}>;

const DiffLabelsTitle: React.FC<Props> = ({
  side,
  children,
}) => {
  const { displayType } = useVisualSelector(selectors.getDiffUi);
  return (
    <div
      className={classnames(
        'flex items-start absolute top-0 left-0 z-10 max-w-full',
        {
          'right-14': side === ImageType.SNAPSHOT || displayType === DiffUiDisplayType.Single,
        },
      )}
    >
      <div className="flex items-center gap-1 p-2 bg-gray-100 rounded-br min-w-0">
        <Typography
          className="m-0 font-semibold"
          variant="body-large"
        >
          {side === ImageType.SNAPSHOT ? 'Current' : 'Baseline'}
        </Typography>
        {children}
      </div>
    </div>
  );
};
export default DiffLabelsTitle;
